import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cases: {
    loading: false,
    totalAssetsValueLoading: false,
    documentsLoading: false,
    reportsLoading: false,
  },
};

export const CasesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    setLoadingStateEnable: (state, action) => {
      state.cases = { ...state.cases, loading: true };
    },
    setLoadingStateDisable: (state) => {
      state.cases = { ...state.cases, loading: false };
    },
    setTotalAssetsLoadingStateEnable: (state, action) => {
      state.cases = { ...state.cases, totalAssetsValueLoading: true };
    },
    setTotalAssetsLoadingStateDisable: (state) => {
      state.cases = { ...state.cases, totalAssetsValueLoading: false };
    },
    setDocumentsLoadingStateEnable: (state, action) => {
      state.cases = { ...state.cases, documentsLoading: true };
    },
    setDocumentsLoadingStateDisable: (state) => {
      state.cases = { ...state.cases, documentsLoading: false };
    },
    setReportsLoadingStateEnable: (state, action) => {
      state.cases = { ...state.cases, reportsLoading: true };
    },
    setReportsLoadingStateDisable: (state) => {
      state.cases = { ...state.cases, reportsLoading: false };
    },
  },
});

export const {
  setLoadingStateEnable,
  setLoadingStateDisable,
  setTotalAssetsLoadingStateEnable,
  setTotalAssetsLoadingStateDisable,
  setDocumentsLoadingStateEnable,
  setDocumentsLoadingStateDisable,
  setReportsLoadingStateEnable,
  setReportsLoadingStateDisable,
} = CasesSlice.actions;

export default CasesSlice.reducer;
